import { SearchType } from './search-type';

/**
 * Active directory search options
 */
export interface ActiveDirectorySearchOptions {
    /**
     * text to build LDAP search string CN part.
     * If searchOn is 'custom', this content will be used literally as LDAP search string.
     */
    searchString: string;
    /**
     * text to build LDAP search string objectCategory/objectClass part
     */
    searchOn?: SearchType | string | (SearchType | string)[];
    /**
     * search result entries size limit
     */
    sizeLimit?: number;
}
